module.exports = __webpack_public_path__ + "media/images/illustrations/wave-white-2-b8208e235e2469795b515318c216c431.svg";